import { render } from "./OutputComp.vue?vue&type=template&id=3020ae0a&scoped=true"
import script from "./OutputComp.vue?vue&type=script&lang=js"
export * from "./OutputComp.vue?vue&type=script&lang=js"

import "./OutputComp.vue?vue&type=style&index=0&id=3020ae0a&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\VueJs\\reaction_time_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3020ae0a"]])

export default __exports__